import { ExportFormat } from "@cayo/shared/api/types/schema";

export const getExportIconName = (format: ExportFormat) => {
  switch (format) {
    case "csv":
      return "TextDocument";
    case "excel":
      return "ExcelDocument";
    case "pdf":
      return "PDF";
    default:
      return "Export";
  }
};
